import { Component, Inject, Input, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'system-queue-dialog',
    templateUrl: './system-queue-dialog.component.html',
    styleUrls: ['./system-queue-dialog.component.scss'],
    standalone: false
})


export class SystemQueueDialogComponent implements OnInit {
    @Input() public items: any[] = [];

    public filteredItems: string = "";

    constructor(
        public dialogRef: MatDialogRef<SystemQueueDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) { }

    ngOnInit() {
        this.items = this.data.items ?? [];
    }

    closeDialog(): void {
        this.dialogRef.close();
    }
}